import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  pageLoading();
  modalImage();

  // お問い合わせ用バリデーション
  if (document.body.classList.contains('contact')) {
    topValidation();
  }

  // btn-toggle
  const btnTrigger = document.querySelector('.btn-toggle');
  const navGlobal = document.querySelector('.header_inner');

  if (btnTrigger && navGlobal) {

    function toggleNav() {
      btnTrigger.classList.toggle('is-open');
      navGlobal.classList.toggle('is-open');
    }

    btnTrigger.addEventListener('click', toggleNav);
  }

  // 商品案内詳細のスライダー 
  const thumbSwiper = new Swiper('.product_slider_thumbs', {
    slidesPerView: 3,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },
  });
  
  const mainSwiper = new Swiper('.product_slider_main', {
    loop: true,
    speed: 500,
    thumbs: {
      swiper: thumbSwiper,
    },
    navigation: {
      nextEl: '.thumb-button-next',
      prevEl: '.thumb-button-prev',
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
  });

  const wrapper = document.querySelector('.index_products_unit__content');
  const swiperWrapper = document.querySelector('.index_products_unit__slide_parent');

  // 要素が存在しない場合は処理をスキップ
  if (wrapper && swiperWrapper) {
    // 768pxをブレークポイントとして方向を決定
    const getDirection = () => {
      return window.innerWidth < 768 ? 'horizontal' : 'vertical';
    };

    function setSwiperHeight() {
      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        // スマホの場合：最も高いスライドの高さを取得
        const slides = document.querySelectorAll('.index_products_unit__slide_wrapper .swiper-slide');
        let maxHeight = 0;
        slides.forEach(slide => {
          const height = slide.getBoundingClientRect().height;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
        if (maxHeight > 0) {
          swiperWrapper.style.setProperty('height', `${maxHeight}px`);
        }
      } else {
        // PCの場合は高さを設定（スライドの実際のスクロール高さを使用）
        const height = wrapper.getBoundingClientRect().height;
        swiperWrapper.style.setProperty('height', `${height}px`);
      }
      if (window.swiperInstance) {
        window.swiperInstance.update();
      }
    }

    // 初期化とリサイズ監視
    const ro = new ResizeObserver(setSwiperHeight);
    ro.observe(wrapper);

    // Swiperの初期化関数
    const initSwiper = () => {
    // 既存インスタンスを破棄
    if (window.swiperInstance) {
      window.swiperInstance.destroy(true, true);
    }
    const isMobile = window.innerWidth < 768;
    window.swiperInstance = new Swiper('.index_products_unit__slide_wrapper', {
      direction: getDirection(),
      slidesPerView: 2,
      spaceBetween: isMobile ? 20 : 50,
      loop: true,
      centeredSlides: true,
      speed: 8000,
      freeMode: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
    // 初期化後に高さを設定
    setSwiperHeight();
  };

  // 初期化
  initSwiper();

  // ウィンドウリサイズ時に方向が変わったら再初期化
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const newWidth = window.innerWidth;
    const lastDirection = lastWidth < 768 ? 'horizontal' : 'vertical';
    const newDirection = newWidth < 768 ? 'horizontal' : 'vertical';

    // 方向が変わった場合のみ再初期化
    if (lastDirection !== newDirection) {
      initSwiper();
    } else {
      // 方向が変わらない場合は高さのみ更新
      setSwiperHeight();
    }

    lastWidth = newWidth;
  });
  }

  // メインイメージの動き
  const mainSub = document.querySelector(".mainimg_sub");
  const mainImgSub = document.querySelector(".mainimg_sub_bg img");

  if(mainSub && mainImgSub) {
    const isMobile = window.innerWidth < 768;
    const startValue = isMobile ? "bottom 200px" : "bottom 400px";
    
    gsap.to(mainImgSub, {
      scale: 1.1,
      filter: "blur(20px)",
      ease: "none",
      scrollTrigger: {
        trigger: mainSub,
        start: startValue,
        end: "bottom 0px",
        scrub: true,
        // markers: true,
      }
    });
  }

  // メインイメージの動き
  const main = document.querySelector(".mainimg");
  const mainImg = document.querySelector(".mainimg_bg img");

  if(main && mainImg) {
    gsap.to(mainImg, {
      scale: 1.1,
      filter: "blur(20px)",
      ease: "none",
      scrollTrigger: {
        trigger: main,
        start: "bottom 40%",
        end: "bottom 0%",
        scrub: true,
        // markers: true,
      }
    });
  }

  // メインイメージの動き
  const blurParents = document.querySelectorAll(".scroll_blur");
  
  blurParents.forEach(blurParent => {
    const blurChild = blurParent.querySelector("img");

    if(blurParent && blurChild) {
      gsap.to(blurChild, {
        scale: 1.05,
        filter: "blur(20px)",
        ease: "none",
        scrollTrigger: {
          trigger: blurParent,
          start: "bottom 50%",
          end: "bottom 0%",
          scrub: true,
          // markers: true,
        }
      });
    }
  });

  // index_intro_unit__img のパララックス効果
  const introImages = document.querySelectorAll('.parallax_img');
  introImages.forEach(el => {
    gsap.set(el, { y: 25 });
    gsap.to(el, {
      y: -25,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        end: "bottom 20%",
        scrub: 1,
      }
    });
  });

  // 子要素に関係なく、クラスを付けた要素だけをアニメーション
  const fadeUpSingleItems = document.querySelectorAll('.fadeUp');
  fadeUpSingleItems.forEach((item) => {
    item.style.visibility = 'hidden';
    item.style.filter = 'blur(8px)';
    
    gsap.fromTo(item, 
      { 
        autoAlpha: 0, 
        y: 10, 
        filter: 'blur(8px)' 
      }, 
      { 
        duration: 0.8,
        autoAlpha: 1, 
        y: 0, 
        filter: 'blur(0px)', 
        ease: 'power1.out',
        scrollTrigger: {
          trigger: item,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      }
    );
  });

  const paragraphs = document.querySelectorAll(".move-text");
  paragraphs.forEach((paragraph) => {
    // innerHTMLを取得（brを含めたいので textContentは使わない）
    const htmlContent = paragraph.innerHTML;
    // <br>タグ（クラス含む）をそのままキャプチャして分割
    const parts = htmlContent.split(/(<br[^>]*>)/i);

    // 各部分を処理
    const newHtmlContent = parts
      .map((part) => {
        // part が <br>タグそのものならそのまま返す
        if (/<br[^>]*>/i.test(part)) {
          return part;
        }
        // それ以外は1文字ずつspanで囲む
        return [...part]
          .map((char) => (char === " " ? `<span>&nbsp;</span>` : `<span>${char}</span>`))
          .join("");
      })
      .join("");

    paragraph.innerHTML = newHtmlContent;

    // GSAPアニメーション
    gsap.fromTo(
      paragraph.querySelectorAll("span"),
      {
        autoAlpha: 0,
        y: 20,
        
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        scrollTrigger: {
          trigger: paragraph,
          start: "top 80%",
          ease: "circ.in",
          toggleActions: "play none none none",
        },
      }
    );
  });

  const paragraphs2 = document.querySelectorAll(".move-text-2");
  paragraphs2.forEach((paragraph) => {
    // innerHTMLを取得（brを含めたいので textContentは使わない）
    const htmlContent = paragraph.innerHTML;
    // <br>タグ（クラス含む）をそのままキャプチャして分割
    const parts = htmlContent.split(/(<br[^>]*>)/i);

    // 各部分を処理
    const newHtmlContent = parts
      .map((part) => {
        // part が <br>タグそのものならそのまま返す
        if (/<br[^>]*>/i.test(part)) {
          return part;
        }
        // すべてのホワイトスペース（改行、タブ、複数スペース）を完全に除去
        const normalizedPart = part.replace(/\s+/g, "");
        
        // 1文字ずつspanで囲む（スペースは処理しない）
        return [...normalizedPart]
          .map((char) => `<span>${char}</span>`)
          .join("");
      })
      .join("");

    paragraph.innerHTML = newHtmlContent;

    // GSAPアニメーション
    gsap.fromTo(
      paragraph.querySelectorAll("span"),
      {
        autoAlpha: 0,
        scale: 1.5,
        filter: "blur(8px)",
      },
      {
        autoAlpha: 1,
        scale: 1,
        filter: "blur(0px)",
        duration: 0.6,
        stagger: 0.05,
        scrollTrigger: {
          trigger: paragraph,
          start: "top 80%",
          ease: "back.out",
          toggleActions: "play none none none",
        },
      }
    );
  });
});

const adjustTtlPosition = () => {
  const targetB = document.querySelector('.first-letter');
  const ttlJa = document.querySelector('.ttl_ja');

  if (!targetB || !ttlJa) return;

  const update = () => {
    // 小数点以下の精度で幅を取得（fluid-font-size対応）
    const rect = targetB.getBoundingClientRect();
    if (rect.width > 0) {
      ttlJa.style.left = `${rect.width}px`;
      ttlJa.style.transform = 'translate(0, 0)';
    }
  };

  // 【重要】ResizeObserver で要素のサイズ変化を常に監視
  // box: 'border-box' を指定することで、より確実に検知させます
  const ro = new ResizeObserver(() => {
    requestAnimationFrame(update);
  });

  // Bそのものを監視
  ro.observe(targetB);

  // 初回実行（念のため複数回たたく）
  update();
  
  // フォント読み込み完了や画像読み込みなどでレイアウトが変わった瞬間にも実行
  window.addEventListener('load', update);
  // 画面リサイズイベントもバックアップとして入れておく
  window.addEventListener('resize', update);
};

// 実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', adjustTtlPosition);
} else {
  adjustTtlPosition();
}

function updateHeaderLayout() {
  const header = document.querySelector('.header');
  const headerInner = document.querySelector('.header_inner');
  const logo = document.querySelector('.header_logo');
  const mainImg = document.querySelector('.mainimg');
  const mainImgSub = document.querySelector('.mainimg_sub');
  
  if (!header || !headerInner || !logo) return;

  const windowWidth = window.innerWidth;
  const thresholdWidth = 1200;

  // --- 【1】1200px未満（モバイル/タブレット）の挙動 ---
  if (windowWidth < thresholdWidth) {
    // ロゴを .header 直下（外）へ移動
    if (logo.parentElement !== header) {
      header.insertBefore(logo, headerInner);
    }
    
    // メイン画像のパディングをリセット
    if (mainImg) mainImg.style.paddingTop = '';
    if (mainImgSub) mainImgSub.style.paddingTop = '';

    // クラスをリセットして終了（スクロール判定は行わない）
    header.classList.remove('is-hidden', 'is-scroll');
    return;
  } 

  // --- 【2】1200px以上（PC）の挙動 ---
  
  // ロゴを .header_inner の中へ戻す
  if (logo.parentElement !== headerInner) {
    headerInner.prepend(logo);
  }

  // 【改善】フォント読み込みやレイアウト計算を完全に完了させるため、複数フレーム待つ
  // SP→PC切り替え時など、メディアクエリ再評価でフォントサイズが変わる可能性があるため
  // requestAnimationFrameを2段階にして確実に反映させる
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const headerHeight = headerInner.offsetHeight;
      if (mainImg) mainImg.style.paddingTop = headerHeight + 'px';
      if (mainImgSub) mainImgSub.style.paddingTop = headerHeight + 'px';
      updateHeaderScroll();
    });
  });
}

// スクロール判定ロジックを分離
function updateHeaderScroll() {
  if (window.innerWidth < 1200) return; // スマホ・タブレットは処理しない

  const header = document.querySelector('.header');
  const headerInner = document.querySelector('.header_inner');
  const mainImg = document.querySelector('.mainimg');
  const mainImgSub = document.querySelector('.mainimg_sub');
  
  if (!header || !headerInner) return;

  // --- 【3】スクロール判定ロジック ---
  const scrollPos = window.scrollY;
  const headerHeight = headerInner.offsetHeight;
  let targetBottom = 0;

  // 判定基準となるターゲット（画像）の最下部を特定
  [mainImg, mainImgSub].forEach(el => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const bottomPos = rect.bottom + scrollPos;
      if (bottomPos > targetBottom) {
        targetBottom = bottomPos;
      }
    }
  });

  // クラスの切り替え
  if (scrollPos > targetBottom) {
    // メイン画像を過ぎたら表示
    header.classList.add('is-scroll');
    header.classList.remove('is-hidden');
  } else if (scrollPos > headerHeight) {
    // ヘッダー分だけスクロールしたら一旦隠す
    header.classList.add('is-hidden');
    header.classList.remove('is-scroll');
  } else {
    // トップ位置
    header.classList.remove('is-hidden', 'is-scroll');
  }
}

// 【改善】DOMContentLoaded内で初期化とイベントリスナー登録
document.addEventListener('DOMContentLoaded', () => {
  // 初期化（全要素が配置された後に実行）
  requestAnimationFrame(() => {
    updateHeaderLayout();
  });
  
  // イベントリスナーの登録（リサイズとスクロール）
  let resizeTimer;
  window.addEventListener('scroll', updateHeaderScroll, { passive: true });
  window.addEventListener('resize', () => {
    // リサイズはバウンス処理でパフォーマンス向上
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeaderLayout, 150);
  });
})

const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
  const textareas = document.querySelectorAll('.wpcf7-form textarea');
  textareas.forEach(el => {
    el.setAttribute('data-lenis-prevent', 'true');
  });
});

